(() => {
  const parseMap = (source) => {
    const map = {};
    String(source || '').split(/\r?\n/).forEach((line) => {
      const separator = line.indexOf('|');
      if (separator < 0) return;
      const name = line.slice(0, separator).trim();
      const rawValue = line.slice(separator + 1).trim();
      if (!name) return;
      if (!rawValue) {
        map[name] = { type: 'empty', value: '' };
      } else if (/^https?:\/\//i.test(rawValue)) {
        map[name] = { type: 'image', value: rawValue };
      } else if (rawValue.includes(',')) {
        map[name] = { type: 'gradient', value: rawValue.split(',').map((value) => value.trim()).filter(Boolean) };
      } else {
        map[name] = { type: 'hex', value: rawValue };
      }
    });
    return map;
  };

  window.colorSwatches = parseMap(window.tlColorSwatchSource);

  const segmentedGradient = (colors) => {
    const size = colors.length;
    if (!size) return '';
    return `linear-gradient(to right, ${colors.flatMap((color, index) => {
      const start = (index / size) * 100;
      const end = ((index + 1) / size) * 100;
      return [`${color} ${start}%`, `${color} ${end}%`];
    }).join(', ')})`;
  };

  const applyColorSwatch = (colorName, element) => {
    if (!element) return;
    const hasColorMaster = element.dataset.colorMasterMatch === 'true';
    const masterImage = element.dataset.colorMasterImage;
    const masterColor = element.dataset.colorMasterColor;
    const swatch = hasColorMaster ? null : window.colorSwatches[String(colorName || '').trim()];
    element.style.background = '';
    element.style.backgroundColor = '';
    element.style.backgroundImage = '';
    element.style.backgroundPosition = '';
    element.style.backgroundRepeat = '';
    element.style.backgroundSize = '';
    element.removeAttribute('data-swatch-unconfigured');

    if (hasColorMaster) {
      if (masterImage) {
        element.style.backgroundImage = `url(${JSON.stringify(masterImage)})`;
        element.style.backgroundPosition = 'center';
        element.style.backgroundRepeat = 'no-repeat';
        element.style.backgroundSize = 'cover';
        return;
      }
      if (masterColor) {
        element.style.backgroundColor = masterColor;
        return;
      }
      element.style.backgroundColor = '#d9d9d9';
      element.dataset.swatchUnconfigured = 'true';
      return;
    }

    if (!swatch || swatch.type === 'empty') {
      element.style.backgroundColor = '#d9d9d9';
      element.dataset.swatchUnconfigured = 'true';
      return;
    }
    if (swatch.type === 'image') {
      element.style.backgroundImage = `url(${JSON.stringify(swatch.value)})`;
      element.style.backgroundPosition = 'center';
      element.style.backgroundRepeat = 'no-repeat';
      element.style.backgroundSize = 'cover';
      return;
    }
    if (swatch.type === 'gradient') {
      element.style.background = segmentedGradient(swatch.value);
      return;
    }
    element.style.backgroundColor = swatch.value;
  };

  window.applyColorSwatch = applyColorSwatch;

  const markLightProductSwatch = (element) => {
    if (!element.closest('.tl-color-selector__item')) return;
    const style = window.getComputedStyle(element);
    const rgb = style.backgroundColor.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
    const channels = rgb ? rgb.slice(1).map(Number) : [];
    const isLightSolidColor = style.backgroundImage === 'none'
      && channels.length === 3
      && Math.min(...channels) >= 205
      && channels.reduce((sum, channel) => sum + channel, 0) / 3 >= 228;
    element.toggleAttribute('data-light-swatch', isLightSolidColor);
  };

  const hydrateProductDetailSwatches = (scope = document) => {
    const buttons = [];
    if (scope.matches?.('.tl-color-selector__item')) buttons.push(scope);
    scope.querySelectorAll?.('.tl-color-selector__item').forEach((button) => buttons.push(button));
    buttons.forEach((button) => {
      const element = button.querySelector('[data-color-swatch]') || button.querySelector('span');
      const colorName = button.dataset.optionValue;
      if (!element || !colorName) return;
      element.dataset.colorSwatch = '';
      element.dataset.colorName = colorName;
      const displayName = button.dataset.colorDisplayName || element.dataset.colorDisplayName || colorName;
      button.setAttribute('aria-label', `カラー：${displayName}`);
      button.title = displayName;
      if (button.dataset.colorMasterMatch) element.dataset.colorMasterMatch = button.dataset.colorMasterMatch;
      if (button.dataset.colorMasterImage) element.dataset.colorMasterImage = button.dataset.colorMasterImage;
      if (button.dataset.colorMasterColor) element.dataset.colorMasterColor = button.dataset.colorMasterColor;
      if (button.dataset.colorDisplayName) element.dataset.colorDisplayName = button.dataset.colorDisplayName;
    });

    scope.querySelectorAll?.('.tl-color-selector').forEach((fieldset) => {
      const selected = fieldset.querySelector('.tl-color-selector__item.is-selected');
      const selectedLabel = fieldset.querySelector('[data-selected-color]');
      if (selected && selectedLabel) selectedLabel.textContent = selected.dataset.colorDisplayName || selected.dataset.optionValue;
    });
  };

  const applyWithin = (scope = document) => {
    hydrateProductDetailSwatches(scope);
    if (scope.matches?.('[data-color-swatch]')) {
      const displayName = scope.dataset.colorDisplayName || scope.dataset.colorName;
      if (scope.matches('[data-tl-card-swatch]') && displayName) {
        scope.title = displayName;
        scope.setAttribute('aria-label', `カラー：${displayName}`);
      }
      applyColorSwatch(scope.dataset.colorName, scope);
      markLightProductSwatch(scope);
    }
    scope.querySelectorAll?.('[data-color-swatch]').forEach((element) => {
      const displayName = element.dataset.colorDisplayName || element.dataset.colorName;
      if (element.matches('[data-tl-card-swatch]') && displayName) {
        element.title = displayName;
        element.setAttribute('aria-label', `カラー：${displayName}`);
      }
      applyColorSwatch(element.dataset.colorName, element);
      markLightProductSwatch(element);
    });
  };

  const updateCard = (button) => {
    const card = button.closest('.tl-product-card');
    if (!card) return;
    card.querySelectorAll('[data-tl-card-swatch]').forEach((item) => {
      const active = item === button;
      item.classList.toggle('is-selected', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    const image = card.querySelector('.tl-product-card__image');
    if (image && button.dataset.variantImage) {
      const token = `${button.dataset.variantId}-${Date.now()}`;
      card.dataset.tlImageRequest = token;
      const nextImage = new Image();
      nextImage.src = button.dataset.variantImage;
      if (button.dataset.variantImageSrcset) nextImage.srcset = button.dataset.variantImageSrcset;
      if (button.dataset.variantImageSizes) nextImage.sizes = button.dataset.variantImageSizes;
      const swapImage = () => {
        if (card.dataset.tlImageRequest !== token) return;
        image.classList.add('is-changing');
        window.setTimeout(() => {
          if (card.dataset.tlImageRequest !== token) return;
          image.src = button.dataset.variantImage;
          if (button.dataset.variantImageSrcset) image.srcset = button.dataset.variantImageSrcset;
          if (button.dataset.variantImageSizes) image.sizes = button.dataset.variantImageSizes;
          if (button.dataset.variantImageWidth) image.width = Number(button.dataset.variantImageWidth);
          if (button.dataset.variantImageHeight) image.height = Number(button.dataset.variantImageHeight);
          image.alt = button.dataset.variantImageAlt || '';
          requestAnimationFrame(() => image.classList.remove('is-changing'));
        }, 40);
      };
      if (typeof nextImage.decode === 'function') nextImage.decode().then(swapImage).catch(swapImage);
      else if (nextImage.complete) swapImage();
      else {
        nextImage.addEventListener('load', swapImage, { once: true });
        nextImage.addEventListener('error', () => image.classList.remove('is-changing'), { once: true });
      }
    }

    const currentPrice = card.querySelector('[data-tl-price-current]');
    const comparePrice = card.querySelector('[data-tl-price-compare]');
    const price = card.querySelector('[data-tl-card-price]');
    const isSale = Boolean(button.dataset.variantComparePrice) && Number(button.dataset.variantComparePriceCents) > Number(button.dataset.variantPriceCents);
    if (currentPrice) currentPrice.textContent = button.dataset.variantPrice;
    if (comparePrice) {
      comparePrice.textContent = isSale ? button.dataset.variantComparePrice : '';
      comparePrice.hidden = !isSale;
    }
    if (price) price.classList.toggle('tl-price--sale', isSale);
    const discountPercent = card.querySelector('[data-tl-price-discount]');
    if (discountPercent) {
      const original = Number(button.dataset.variantComparePriceCents);
      const current = Number(button.dataset.variantPriceCents);
      discountPercent.textContent = isSale ? `${Math.floor((original - current) * 100 / original)}% OFF` : '';
      discountPercent.hidden = !isSale;
    }
    const saleBadge = card.querySelector('[data-tl-sale-badge]');
    if (saleBadge) {
      const original = Number(button.dataset.variantComparePriceCents);
      const current = Number(button.dataset.variantPriceCents);
      saleBadge.textContent = isSale ? `${Math.floor((original - current) * 100 / original)}% OFF` : '';
      saleBadge.hidden = !isSale;
    }

    if (button.dataset.variantUrl) {
      card.querySelectorAll('[data-tl-card-product-link]').forEach((link) => {
        const destination = new URL(button.dataset.variantUrl, window.location.origin);
        destination.searchParams.delete('variant');
        destination.searchParams.set('tl_card_variant', button.dataset.variantId);
        link.href = destination.toString();
      });
    }
  };

  // TL: 色ボタンに触れた時点で、その色の画像を先に読んでおく（押した時に待たせないため）
  const preloadedCardImages = new Set();
  const preloadCardImage = (button) => {
    const src = button?.dataset?.variantImage;
    if (!src || preloadedCardImages.has(src)) return;
    preloadedCardImages.add(src);
    const img = new Image();
    if (button.dataset.variantImageSizes) img.sizes = button.dataset.variantImageSizes;
    if (button.dataset.variantImageSrcset) img.srcset = button.dataset.variantImageSrcset;
    img.src = src;
  };
  const preloadFromEvent = (event) => {
    const button = event.target?.closest?.('[data-tl-card-swatch]');
    if (button) preloadCardImage(button);
  };
  document.addEventListener('pointerover', preloadFromEvent, { passive: true });
  document.addEventListener('touchstart', preloadFromEvent, { passive: true });
  document.addEventListener('focusin', preloadFromEvent);

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-tl-card-swatch]');
    if (!button) return;
    event.preventDefault();
    updateCard(button);
  });

  const initialize = (scope = document) => applyWithin(scope);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('tl:product-cards-rendered', (event) => initialize(event.detail?.root || document));

  const observer = new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) applyWithin(node);
    }));
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
